import { ImageIcon, PlusIcon } from './Icons';
import { useEffect, useState } from 'react';
import type { Product } from '../types/api';
import { resolveApiUrl } from '../services/api';
import ProductImage from './ProductImage';
import './ProductCard.css';

interface Props {
  product: Product;
  isAuthenticated: boolean;
  onAddToCart?: (productId: string, productName: string, price: number) => void;
}

export default function ProductCard({ product, isAuthenticated, onAddToCart }: Props) {
  const [imageSrc, setImageSrc] = useState(resolveApiUrl(product.image));
  const hasRealImage = Boolean(product.image) && !product.image.includes('product-placeholder.svg');

  useEffect(() => {
    setImageSrc(resolveApiUrl(product.image));
  }, [product.image]);

  return (
    <div className="product-card">
      <div className="product-card-image">
        {hasRealImage && imageSrc ? (
          <ProductImage
            src={imageSrc}
            alt={product.name}
            onFinalError={() => setImageSrc(resolveApiUrl('/api/assets/product-placeholder.svg'))}
          />
        ) : (
          <div className="product-card-placeholder" aria-hidden="true">
            <div className="product-card-placeholder-badge">MX</div>
            <ImageIcon size={22} />
            <strong>{product.category || 'Catalogo'}</strong>
            <span>Imagem em atualizacao</span>
          </div>
        )}
        {(!isAuthenticated || !product.active) && <div className="product-card-lock">Entre para consultar o preço</div>}
      </div>
      <div className="product-card-body">
        <span className="product-card-category">{product.category}</span>
        <p className="product-card-name">{product.name}</p>
        <p className="product-card-code">Ref. {product.code}</p>
        <div className="product-card-footer">
          {isAuthenticated && product.price != null ? (
            <span className="product-card-price">
              {product.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </span>
          ) : (
            <span className="product-card-price-hidden">Preço sob login</span>
          )}
          <button
            className="product-card-add"
            disabled={!isAuthenticated || !product.active || !product.available}
            onClick={() => onAddToCart?.(product.id, product.name, product.price || 0)}
            aria-label="Adicionar ao carrinho"
            type="button"
          >
            <PlusIcon size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
